import { jsx } from "react/jsx-runtime";
import { createContext, useContext } from "react";
import { useFilterEmployees } from "../../hooks/useFilterEmployees/useFilterEmployees.js";
import "../../type/Translations.js";
import "../../type/Employee.js";
import "../../utils/array.js";
import "fast-memoize";
import "../../utils/employee/getUniqueByRoles.js";
import "lodash/reverse.js";
import "lodash/uniqBy.js";
import "lodash";
const EmployeesFilterContext = createContext({
  isRoleSelected: () => false,
  isAllEmployeesByRoleSelected: () => false,
  selectedEmployeesEntities: {},
  selectedEmployeeReferenceIds: [],
  selectedEmployees: [],
  toggleAllByRole: () => {
  },
  toggleEmployee: () => {
  },
  toggleAll: () => {
  },
  clearAll: () => {
  },
  isAllSelected: true,
  setSearchedEmployeeString: () => {
  },
  searchedEmployeeString: "",
  filteredEmployees: [],
  filteredSelectedEmployeeReferenceIds: [],
  employeesByRoles: {},
  showDeactivatedEmployees: false,
  setShowDeactivatedEmployees: () => {
  },
  showWorkingEmployees: false,
  setShowWorkingEmployees: () => {
  },
  filteredSelectedEmployees: []
});
const EmployeesFiltersProvider = ({
  children,
  employees = [],
  language,
  initialSelectedEmployeeIds,
  initialShowWorkingEmployees,
  initialSearchedEmployeeString
}) => {
  const employeesFilter = useFilterEmployees({
    initialEmployees: employees,
    language,
    initialSelectedEmployeeIds,
    initialShowWorkingEmployees,
    initialSearchedEmployeeString
  });
  return /* @__PURE__ */ jsx(EmployeesFilterContext.Provider, { value: employeesFilter, children });
};
const useEmployeesFiltersContext = () => {
  const context = useContext(EmployeesFilterContext);
  if (context === void 0) {
    throw new Error("useEmployeesFiltersContext must be used within EmployeesFiltersProvider ");
  }
  return context;
};
export {
  EmployeesFilterContext,
  EmployeesFiltersProvider,
  useEmployeesFiltersContext
};
